<template>
  <Modal title="認証キーの登録" @close="close" hideCloseButton>
    <div class="description">
      POS+との連携には、ぐるなび台帳に登録した認証キーを<br />
      POS+管理画面に入力する必要があります。<br />
      認証キーは8文字以上、英数字を組み合わせて登録してください。
    </div>
    <FormGrid class="auth-key">
      <dt>認証キー</dt>
      <dd>
        <AdornmentsInput
          :type="type"
          :prefixIcon="LockIcon"
          maxlength="20"
          placeholder="認証キー"
          autocomplete="nope"
          v-model.trim="authKey"
          @focus="typeChange"
        />
        <div class="validation-item">
          <CheckIcon :class="['check', { 'is-ok': isOver }]" circle width="20" height="20" />
          <span>8文字以上</span>
        </div>
        <div class="validation-item">
          <CheckIcon :class="['check', { 'is-ok': isMixed }]" circle width="20" height="20" />
          <span>英字と数字を含む</span>
        </div>
      </dd>
      <dt>認証キー（確認用）</dt>
      <dd>
        <AdornmentsInput
          :type="type"
          :prefixIcon="LockIcon"
          maxlength="20"
          placeholder="認証キー（確認用）"
          autocomplete="nope"
          v-model.trim="reinput"
          @focus="typeChange"
        />
        <div class="validation-item">
          <CheckIcon :class="['check', { 'is-ok': isMatch && isDirty }]" circle width="20" height="20" />
          <span>認証キーが一致</span>
        </div>
      </dd>
    </FormGrid>
    <template #footer-center>
      <Button @click="close">戻る</Button>
      <Button primary @click="register" :disabled="isDisabled">登録</Button>
    </template>
  </Modal>
</template>
<script>
import Modal from '@/components/molecules/Modal'
import Button from '@/components/atoms/Button'
import CheckIcon from '@/components/icons/CheckIcon'
import LockIcon from '@/components/icons/lock'
import AdornmentsInput from '@/components/molecules/AdornmentsInput'
import FormGrid from '@/components/molecules/FormGrid'

export default {
  name: 'PosKeyRegisterModal',
  components: {
    Modal,
    Button,
    CheckIcon,
    AdornmentsInput,
    FormGrid,
  },
  data() {
    return {
      type: 'text',
      authKey: '',
      reinput: '',
      LockIcon,
    }
  },
  computed: {
    isDirty() {
      return this.authKey !== '' && this.reinput !== ''
    },
    isMatch() {
      return this.authKey === this.reinput
    },
    isOver() {
      return this.authKey.length >= 8 && this.authKey.length <= 20
    },
    isMixed() {
      return this.authKey !== '' && /([0-9][a-zA-Z]|[a-zA-Z][0-9])/.test(this.authKey)
    },
    isDisabled() {
      return !this.isDirty || !this.isMatch || !this.isOver || !this.isMixed
    },
  },
  methods: {
    typeChange() {
      this.type = 'password'
    },
    close() {
      this.$emit('close')
    },
    register() {
      this.$emit('register', { newPassword: this.authKey, confirmPassword: this.reinput })
    },
  },
}
</script>

<style lang="postcss" scoped>
.auth-key {
  grid-template-columns: 136px 1fr;

  > dt {
    font-weight: 400;
  }
}

.validation-item {
  align-items: center;
  column-gap: 10px;
  display: flex;
  padding: 0 18px;
}

.check {
  fill: var(--light-gray);

  &.is-ok {
    fill: #1abc9c;

    & + span {
      font-weight: 600;
    }
  }
}
</style>
